const Footer = () => {
    // return (
    //     <footer className="site-footer">
    //         <div id="copyright">
    //             <div className="container">
    //                 <div className="row">
    //                     <div className="col-md-4">
    //                         <p className="pull-left">&copy; 2024 Suparna Travels LLC</p>
    //                     </div>

    //                 </div>
    //             </div>
    //         </div>
    //     </footer>
    // )
    return (
        <footer className="ftco-footer bg-bottom ftco-no-pt" style={{ backgroundImage: "url(assets/images/bg_3.jpg)" }}>
            <div className="container">
                <div className="row mb-1">
                    <div className="col-md pt-2">
                        <div className="ftco-footer-widget pt-md-2 mb-2">
                            <h2 className="ftco-heading-2">About</h2>
                            <p>Best travellers.</p>
                            <ul className="ftco-footer-social list-unstyled float-md-left float-lft">
                                <li className=""><a href="#"><span className="fa fa-twitter"></span></a></li>
                                <li className=""><a href="#"><span className="fa fa-facebook"></span></a></li>
                                <li className=""><a href="#"><span className="fa fa-instagram"></span></a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md pt-2 border-left">
                        <div className="ftco-footer-widget pt-md-2 mb-2 ml-md-5">
                            <h2 className="ftco-heading-2">Infromation</h2>
                            <ul className="list-unstyled">
                                <li><a href="#" className="py-2 d-block">Online Enquiry</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md pt-2 border-left">
                        <div className="ftco-footer-widget pt-md-2 mb-2">
                            <h2 className="ftco-heading-2">Experience</h2>
                            <ul className="list-unstyled">
                                <li><a href="#" className="py-2 d-block">Adventure</a></li>

                            </ul>
                        </div>
                    </div>
                    <div className="col-md pt-2 border-left">
                        <div className="ftco-footer-widget pt-md-2 mb-2">
                            <h2 className="ftco-heading-2">Have a Questions?</h2>
                            <div className="block-23 mb-3">
                                <ul>
                                    <li><span className="icon fa fa-map-marker"></span><span className="text"> USA</span></li>
                                    {/* <li><a href="#"><span className="icon fa fa-phone"></span><span className="text">+2 392 3929 210</span></a></li>
                                    <li><a href="#"><span className="icon fa fa-paper-plane"></span><span className="text">info@yourdomain.com</span></a></li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 text-center">

                        <p>
                            &copy; 2024 Suparna Travels LLC<script>document.write(new Date().getFullYear())</script>. All rights reserved | This template is made with <i className="fa fa-heart" aria-hidden="true"></i> by <a href="https://colorlib.com" target="_blank">Colorlib</a>
                        </p>
                    </div>
                </div>
            </div>
        </footer>)
}

export default Footer;